import { Component } from 'san';
import { IShowDialogParams } from 'src/models';

export default class Dialoger extends Component {
    _confirmCallback;
    _cancelCallback;

    constructor(options: any) {
        super(options);
    }

    initData(): {
        type: string;
        isBusy: boolean;
        isShow: boolean;
        isShowCloseBtn: boolean;
        title: string;
        content: string;
        remark: string;
        confirmBtnLabel: string;
        cancelBtnLabel: string;
        disableCancel: boolean;
    } {
        return {
            type: 'danger',
            isBusy: false,
            isShow: false,
            isShowCloseBtn: false,
            title: '',
            content: '',
            remark: '',
            confirmBtnLabel: '',
            cancelBtnLabel: '',
            disableCancel: false
        };
    }

    show(params: IShowDialogParams) {
        this.data.set('type', params.type || 'danger');
        this.data.set('isBusy', false);
        this.data.set('isShow', true);
        this.data.set('isShowCloseBtn', params.isShowCloseBtn);
        this.data.set('title', params.title);
        this.data.set('content', params.content);
        this.data.set('remark', params.remark);
        this.data.set('confirmBtnLabel', params.confirmBtnLabel);
        this.data.set('cancelBtnLabel', params.cancelBtnLabel);
        this.data.set('disableCancel', params.disableCancel);
        this._confirmCallback = params.confirmCallback;
        this._cancelCallback = params.cancelCallback;
    }

    submit() {
        if (this.data.get('isBusy')) {
            return;
        }
        this.data.set('isBusy', true);
        this.close();
        if (this._confirmCallback) {
            this._confirmCallback();
        }
    }

    cancel() {
        if (this.data.get('isBusy')) {
            return;
        }
        this.data.set('isBusy', true);
        this.close();
        if (this._cancelCallback) {
            this._cancelCallback();
        }
    }

    close() {
        // 关闭时，不清空title、content等数据，而是在show()时重置数据。防止连续调用show()无效
        this.data.set('isShow', false);
    }
}